import React from 'react'
import GenerateReport from '../components/GenerateReport'
import { generatePublicationReport, getPublicationReport } from '../services/api';

const PublicationReport = () => {
  const config = [
    {
      key: 'standardsPublish',
      apiKey: 'standards_publish',
      type: 'publish',
      title: 'Fastställda standarder',
      moduleId: 'standards-publish',
    },
    {
      key: 'standardsAnnulment',
      apiKey: 'standards_annulment',
      type: 'annulment',
      title: 'Upphävda standarder',
      moduleId: 'standards-annulment'
    },
    {
      key: 'alteredPublForm',
      apiKey: 'altered_publ_form',
      type: 'publish',
      title: 'Ändrad publiceringsform, tidigare ikraftsatt genom offentliggörande',
      moduleId: 'altered-publ-form',
      isEditable: true,
    },
    {
      key: 'addedValue',
      apiKey: 'added_value',
      type: 'publish',
      title: 'Mervärdesprodukter',
      moduleId: 'added-value'
    },
    {
      key: 'trPublish',
      apiKey: 'TR_publish',
      type: 'publish',
      title: 'Publicerade SEK Tekniska Rapporter',
      moduleId: 'TR-publish'
    },
    {
      key: 'tsPublish',
      apiKey: 'TS_publish',
      type: 'publish',
      title: 'Publicerade SEK Tekniska Specifikationer',
      moduleId: 'TS-publish'
    },
    {
      key: 'iecAsSekPubl',
      apiKey: 'iec_as_sek_publ',
      type: 'publish',
      title: 'IEC-publikationer fastställda som SEK-publikationer',
      moduleId: 'iec-as-sek-publ'
    },
    {
      key: 'iecAsSekTr',
      apiKey: 'iec_as_sek_TR',
      type: 'publish',
      title: 'IEC-publikationer fastställda som SEK Tekniska Rapporter',
      moduleId: 'iec-as-sek-tr'
    },
    {
      key: 'iecAsSekTs',
      apiKey: 'iec_as_sek_TS',
      type: 'publish',
      title: 'IEC-publikationer fastställda som SEK Tekniska Specifikationer',
      moduleId: 'iec-as-sek-ts'
    },
  ];

  return (
    <GenerateReport
      type='publicationReport'
      title='publiceringslista'
      name='Ny och upphävd svensk standard'
      initialItems={{
        standardsPublish: [],
        standardsAnnulment: [],
        alteredPublForm: [],
        addedValue: [],
        trPublish: [],
        tsPublish: [],
        iecAsSekPubl: [],
        iecAsSekTr: [],
        iecAsSekTs: [],
      }}
      dateStorageKeys={{
        dop: 'dop_date-PL',
        dowFrom: 'dow_date_from-PL',
        dowTo: 'dow_date_to-PL'
      }}
      config={config}
      fetchReport={({ dopDate, dowDateFrom, dowDateTo }) =>
        getPublicationReport(dopDate, dowDateFrom, dowDateTo)
      }
      generateReport={(dates, report) => {
        const payload = {
          ...report,
          alteredPublForm: report.alteredPublForm.map((item) => ({
            ...item,
            comment: item.comment?.trim() || ''
          }))
        };
        return generatePublicationReport(dates, payload)
      }}
    />
  )
}

export default PublicationReport